import React from 'react';
import WelcomeCard from '../../components/common/WelcomeCard';
import StatisticsCard from '../../components/common/StatisticsCard';
import BestServices from '../../components/common/BestServices';

const Dashboard = () => {
  return (
    <React.Fragment>
      <div className='p-4'>
        <WelcomeCard />

        <div className='mt-4'>
          <StatisticsCard />
        </div>

        {/* <div className='mt-4'>
          <BestServices />
        </div> */}
      </div>
    </React.Fragment>
  );
};

export default Dashboard;












// import React from 'react';
// import WelcomeCard from '../../components/common/WelcomeCard';
// import StatisticsCard from '../../components/common/StatisticsCard';

// const Dashboard = () => {

//   return (
//     <React.Fragment>
//       <div className='p-4'>
//         <WelcomeCard />

//         <div className='mt-4'>
//           <StatisticsCard />
//         </div>
//       </div>
//     </React.Fragment>
//   );
// };

// export default Dashboard;
